/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthErrorRouteImport } from './routes/auth.error'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as WWorkspaceIdRouteImport } from './routes/w.$workspaceId'
import { Route as IntegrationsLinearCallbackRouteImport } from './routes/integrations.linear.callback'
import { Route as WWorkspaceIdIndexRouteImport } from './routes/w.$workspaceId.index'
import { Route as WWorkspaceIdDeliveryRouteImport } from './routes/w.$workspaceId.delivery'
import { Route as WWorkspaceIdMemoryRouteImport } from './routes/w.$workspaceId.memory'
import { Route as WWorkspaceIdSettingsRouteImport } from './routes/w.$workspaceId.settings'
import { Route as WWorkspaceIdConversationsConversationIdRouteImport } from './routes/w.$workspaceId.conversations.$conversationId'
import { Route as WWorkspaceIdInitiativesInitiativeIdRouteImport } from './routes/w.$workspaceId.initiatives.$initiativeId'
import { Route as WWorkspaceIdReviewsIndexRouteImport } from './routes/w.$workspaceId.reviews.index'
import { Route as WWorkspaceIdReviewsSubmissionIdRouteImport } from './routes/w.$workspaceId.reviews.$submissionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
  id: '/w/$workspaceId',
  path: '/w/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsLinearCallbackRoute =
  IntegrationsLinearCallbackRouteImport.update({
    id: '/integrations/linear/callback',
    path: '/integrations/linear/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdIndexRoute = WWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdDeliveryRoute = WWorkspaceIdDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdMemoryRoute = WWorkspaceIdMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdSettingsRoute = WWorkspaceIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdConversationsConversationIdRoute =
  WWorkspaceIdConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdInitiativesInitiativeIdRoute =
  WWorkspaceIdInitiativesInitiativeIdRouteImport.update({
    id: '/initiatives/$initiativeId',
    path: '/initiatives/$initiativeId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdReviewsIndexRoute =
  WWorkspaceIdReviewsIndexRouteImport.update({
    id: '/reviews/',
    path: '/reviews/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdReviewsSubmissionIdRoute =
  WWorkspaceIdReviewsSubmissionIdRouteImport.update({
    id: '/reviews/$submissionId',
    path: '/reviews/$submissionId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/integrations/linear/callback': typeof IntegrationsLinearCallbackRoute
  '/w/$workspaceId/delivery': typeof WWorkspaceIdDeliveryRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/settings': typeof WWorkspaceIdSettingsRoute
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/initiatives/$initiativeId': typeof WWorkspaceIdInitiativesInitiativeIdRoute
  '/w/$workspaceId/reviews/$submissionId': typeof WWorkspaceIdReviewsSubmissionIdRoute
  '/w/$workspaceId/reviews/': typeof WWorkspaceIdReviewsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/integrations/linear/callback': typeof IntegrationsLinearCallbackRoute
  '/w/$workspaceId/delivery': typeof WWorkspaceIdDeliveryRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/settings': typeof WWorkspaceIdSettingsRoute
  '/w/$workspaceId': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/initiatives/$initiativeId': typeof WWorkspaceIdInitiativesInitiativeIdRoute
  '/w/$workspaceId/reviews/$submissionId': typeof WWorkspaceIdReviewsSubmissionIdRoute
  '/w/$workspaceId/reviews': typeof WWorkspaceIdReviewsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/integrations/linear/callback': typeof IntegrationsLinearCallbackRoute
  '/w/$workspaceId/delivery': typeof WWorkspaceIdDeliveryRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/settings': typeof WWorkspaceIdSettingsRoute
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/initiatives/$initiativeId': typeof WWorkspaceIdInitiativesInitiativeIdRoute
  '/w/$workspaceId/reviews/$submissionId': typeof WWorkspaceIdReviewsSubmissionIdRoute
  '/w/$workspaceId/reviews/': typeof WWorkspaceIdReviewsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/error'
    | '/invitations/$token'
    | '/w/$workspaceId'
    | '/integrations/linear/callback'
    | '/w/$workspaceId/delivery'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/settings'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/initiatives/$initiativeId'
    | '/w/$workspaceId/reviews/$submissionId'
    | '/w/$workspaceId/reviews/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/error'
    | '/invitations/$token'
    | '/integrations/linear/callback'
    | '/w/$workspaceId/delivery'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/settings'
    | '/w/$workspaceId'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/initiatives/$initiativeId'
    | '/w/$workspaceId/reviews/$submissionId'
    | '/w/$workspaceId/reviews'
  id:
    | '__root__'
    | '/'
    | '/auth/error'
    | '/invitations/$token'
    | '/w/$workspaceId'
    | '/integrations/linear/callback'
    | '/w/$workspaceId/delivery'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/settings'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/initiatives/$initiativeId'
    | '/w/$workspaceId/reviews/$submissionId'
    | '/w/$workspaceId/reviews/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthErrorRoute: typeof AuthErrorRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  WWorkspaceIdRoute: typeof WWorkspaceIdRouteWithChildren
  IntegrationsLinearCallbackRoute: typeof IntegrationsLinearCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId': {
      id: '/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/w/$workspaceId'
      preLoaderRoute: typeof WWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/linear/callback': {
      id: '/integrations/linear/callback'
      path: '/integrations/linear/callback'
      fullPath: '/integrations/linear/callback'
      preLoaderRoute: typeof IntegrationsLinearCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/': {
      id: '/w/$workspaceId/'
      path: '/'
      fullPath: '/w/$workspaceId/'
      preLoaderRoute: typeof WWorkspaceIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/delivery': {
      id: '/w/$workspaceId/delivery'
      path: '/delivery'
      fullPath: '/w/$workspaceId/delivery'
      preLoaderRoute: typeof WWorkspaceIdDeliveryRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/memory': {
      id: '/w/$workspaceId/memory'
      path: '/memory'
      fullPath: '/w/$workspaceId/memory'
      preLoaderRoute: typeof WWorkspaceIdMemoryRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings': {
      id: '/w/$workspaceId/settings'
      path: '/settings'
      fullPath: '/w/$workspaceId/settings'
      preLoaderRoute: typeof WWorkspaceIdSettingsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/conversations/$conversationId': {
      id: '/w/$workspaceId/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/w/$workspaceId/conversations/$conversationId'
      preLoaderRoute: typeof WWorkspaceIdConversationsConversationIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/initiatives/$initiativeId': {
      id: '/w/$workspaceId/initiatives/$initiativeId'
      path: '/initiatives/$initiativeId'
      fullPath: '/w/$workspaceId/initiatives/$initiativeId'
      preLoaderRoute: typeof WWorkspaceIdInitiativesInitiativeIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/reviews/': {
      id: '/w/$workspaceId/reviews/'
      path: '/reviews'
      fullPath: '/w/$workspaceId/reviews/'
      preLoaderRoute: typeof WWorkspaceIdReviewsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/reviews/$submissionId': {
      id: '/w/$workspaceId/reviews/$submissionId'
      path: '/reviews/$submissionId'
      fullPath: '/w/$workspaceId/reviews/$submissionId'
      preLoaderRoute: typeof WWorkspaceIdReviewsSubmissionIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
  }
}

interface WWorkspaceIdRouteChildren {
  WWorkspaceIdDeliveryRoute: typeof WWorkspaceIdDeliveryRoute
  WWorkspaceIdMemoryRoute: typeof WWorkspaceIdMemoryRoute
  WWorkspaceIdSettingsRoute: typeof WWorkspaceIdSettingsRoute
  WWorkspaceIdIndexRoute: typeof WWorkspaceIdIndexRoute
  WWorkspaceIdConversationsConversationIdRoute: typeof WWorkspaceIdConversationsConversationIdRoute
  WWorkspaceIdInitiativesInitiativeIdRoute: typeof WWorkspaceIdInitiativesInitiativeIdRoute
  WWorkspaceIdReviewsSubmissionIdRoute: typeof WWorkspaceIdReviewsSubmissionIdRoute
  WWorkspaceIdReviewsIndexRoute: typeof WWorkspaceIdReviewsIndexRoute
}

const WWorkspaceIdRouteChildren: WWorkspaceIdRouteChildren = {
  WWorkspaceIdDeliveryRoute: WWorkspaceIdDeliveryRoute,
  WWorkspaceIdMemoryRoute: WWorkspaceIdMemoryRoute,
  WWorkspaceIdSettingsRoute: WWorkspaceIdSettingsRoute,
  WWorkspaceIdIndexRoute: WWorkspaceIdIndexRoute,
  WWorkspaceIdConversationsConversationIdRoute:
    WWorkspaceIdConversationsConversationIdRoute,
  WWorkspaceIdInitiativesInitiativeIdRoute:
    WWorkspaceIdInitiativesInitiativeIdRoute,
  WWorkspaceIdReviewsSubmissionIdRoute: WWorkspaceIdReviewsSubmissionIdRoute,
  WWorkspaceIdReviewsIndexRoute: WWorkspaceIdReviewsIndexRoute,
}

const WWorkspaceIdRouteWithChildren = WWorkspaceIdRoute._addFileChildren(
  WWorkspaceIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthErrorRoute: AuthErrorRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  WWorkspaceIdRoute: WWorkspaceIdRouteWithChildren,
  IntegrationsLinearCallbackRoute: IntegrationsLinearCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
